// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.FindEntityPatientFilesRequest */
/* istanbul ignore next */
@GandalfModel
export class FindEntityPatientFilesRequest extends GandalfModelBase {

	@GandalfConstantDecorator(constants.PatientFileEntityType)
	@GandalfLabel('Entity Type')
	@GandalfValidator({ notNull: { message: 'Entity Type is required' } })
	@GandalfProperty({ designType: constants.PatientFileEntityType, isRequired: true })
	entityType!: constants.PatientFileEntityType;

	@GandalfLabel('Parent')
	@GandalfValidator({ notNull: { message: 'Parent is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	parentId!: number;

	@GandalfLabel('Patient')
	@GandalfValidator({ notNull: { message: 'Patient is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientId!: number;

}
